// Simple row layout
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { type RestOfferCode } from '@bbkAdminUtils/api-client/rest-modals-cards-types';

type Props = {
  offerCode: RestOfferCode;
};
const ModalOfferCode: React.FC<Props> = (props) => {
  const { offerCode } = props;

  const [copied, setCopied] = useState(false);

  return (
    <div className="modal-offer-code">
      <div className="MOCContainer">
        <div className="code">
          <span className="code-text">{offerCode.code}</span>
          <span className="code-copy">
            <CopyToClipboard
              text={offerCode.code}
              onCopy={() => setCopied(true)}
            >
              <span>{copied ? <i>copied</i> : 'copy'}</span>
            </CopyToClipboard>
          </span>
        </div>
        <div className="code-instructions-title">How to redeem:</div>
        <div className="code-instructions">
          {offerCode.how_to.map((ht, i) => (
            <div key={ht}>
              <span className="inst-number">{i + 1}.</span> {ht}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalOfferCode;
